import { GenericConfirmationModal, Row } from '@ydistri/ds';
import React, { useCallback, useState } from 'react';
import DeleteIconButton from '../../../components/buttons/DeleteIconButton';

interface AsoTargetControlsProps {
  isDeleting: boolean;
  onDelete: () => Promise<void>;
  priority: number;
  isDisabled?: boolean;
}

const AsoTargetControls: React.FC<AsoTargetControlsProps> = ({
  isDeleting,
  onDelete,
  priority,
  isDisabled = false,
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const confirmDelete = useCallback(async () => {
    try {
      await onDelete();
      setShowConfirm(false);
    } catch {
      // The owner surfaces the mutation error; keeping this open makes the action retryable.
    }
  }, [onDelete]);

  return (
    <>
      <Row $alignItems="center" $gap="0.5rem">
        <DeleteIconButton
          disabled={isDeleting || isDisabled}
          size="small"
          tooltip="Delete target priority"
          onClick={() => setShowConfirm(true)}
        />
      </Row>
      {showConfirm && (
        <GenericConfirmationModal
          confirmationButtonLabel="Delete target"
          message="You are about to delete this target."
          running={isDeleting}
          title={`Delete target priority ${priority}`}
          onCanceled={() => setShowConfirm(false)}
          onConfirmed={() => void confirmDelete()}
        />
      )}
    </>
  );
};

export default AsoTargetControls;
